import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import {
    IHCTaskAttachmentOption,
    ISaveHHHCTaskAttachmentRequest,
    ISaveHHHCTaskAttachmentResponse
} from "../../../../../../resources-vue/vue-interfaces/i-task";
import { IReassignVisitDetails } from "../../../../../../interfaces/i-reassign-visit";
import {
    homeCareUploadedDocumentationType,
    HomeCareUploadedDocumentationTypeEnum
} from "../../../../../../enums/enums";
import { enumToMap } from "../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { TaskService } from "../../../../../../services/task.service";
import { ToastrService } from "../../../../../../services/toastr.service";

export default defineComponent({
    name: "VisitAttachmentsUploadHC",
    inject: ["dialogRef"],
    data() {
        return {
            taskAttachmentOptions: null as IHCTaskAttachmentOption,
            visitDetails: null as IReassignVisitDetails,
            attachment: null as File,
            documentType: HomeCareUploadedDocumentationTypeEnum.None,
            uploadedDocumentationType: enumToMap(homeCareUploadedDocumentationType),
            uploadedDocumentationTypeEnum: HomeCareUploadedDocumentationTypeEnum,
            isSaving: false as boolean,
            _dialogRef: this.dialogRef as any,
            _taskService: null as TaskService,
            _toastrService: null as ToastrService
        };
    },
    computed: {
        showDocumentTypes() {
            return (
                this.taskAttachmentOptions?.IsPaperDocumentationUploadAllowed ||
                this.taskAttachmentOptions?.IsBulkDocumentationUploadAllowed
            );
        }
    },
    created() {
        this._taskService = Container.instance.get(TaskService);
        this._toastrService = Container.instance.get(ToastrService);
    },
    mounted() {
        const { taskAttachmentOptions, visitDetails } = this._dialogRef?.data;
        if (taskAttachmentOptions && visitDetails) {
            this.taskAttachmentOptions = taskAttachmentOptions;
            this.visitDetails = visitDetails;
        } else this._dialogRef?.close("cancel");
    },
    methods: {
        displayDocumentType(currentOption: HomeCareUploadedDocumentationTypeEnum) {
            return currentOption === HomeCareUploadedDocumentationTypeEnum.SingleVisit
                ? this.taskAttachmentOptions?.IsPaperDocumentationUploadAllowed
                : currentOption === HomeCareUploadedDocumentationTypeEnum.BulkVisit
                  ? this.taskAttachmentOptions?.IsBulkDocumentationUploadAllowed
                  : false;
        },
        uploadFilesChanged(event: any) {
            this.attachment = event.target.files[0];
        },
        removeAttachedFile() {
            this.attachment = null;
        },
        documentTypeChanged(selectedDocumentType: HomeCareUploadedDocumentationTypeEnum) {
            this.documentType = selectedDocumentType;
        },
        async saveAttachment() {
            this.isSaving = true;
            if (this.attachment) {
                try {
                    this.isSaving = true;
                    const formData = new FormData();
                    formData.append(`file0`, this.attachment);
                    const payload: ISaveHHHCTaskAttachmentRequest = {
                        AgencyId: this.visitDetails?.AgencyId,
                        Application: this.visitDetails?.Application,
                        TaskId: this.visitDetails?.Id,
                        PatientId: this.visitDetails?.PatientId,
                        EpisodeId: this.visitDetails?.EpisodeId,
                        UploadedDocumentationType: this.documentType
                    };
                    formData.append("request", JSON.stringify(payload));
                    const response: ISaveHHHCTaskAttachmentResponse =
                        await this._taskService.saveHHHCTaskAttachment(formData);
                    if (response.IsSuccessful) {
                        this.attachment = null;
                        this.documentType = HomeCareUploadedDocumentationTypeEnum.None;
                        (this.$refs.file1 as HTMLInputElement).value = "";
                        this._toastrService.success({
                            title: "Attachment(s) Saved",
                            message: "The attachment(s) have been saved successfully."
                        });
                        this.ok();
                    } else {
                        this._toastrService.error({
                            title: `Error`,
                            message: response.ErrorMessage
                                ? response.ErrorMessage
                                : response.Message
                                  ? response.Message
                                  : "Error uploading file, please try again."
                        });
                    }
                } catch (error) {
                    console.error(error);
                    this._toastrService.error({
                        title: `Error`,
                        message: "Error uploading file, please try again."
                    });
                }
                this.isSaving = false;
            } else {
                this.isSaving = false;
                this._toastrService.error({
                    title: `Error`,
                    message: `Please fill required Fields`
                });
            }
        },

        ok() {
            this._dialogRef.close();
        },

        cancel() {
            this._dialogRef.close("cancel");
        }
    }
});
